import { faCode, faLaptop, faLaptopCode, faPaintBrush, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import BubblesParticlesBackground from '../ParticlesBackground/BubblesParticlesBackground';
import './Services.css'

const servicesData = [
    {
        id: 1,
        title: 'Web Development',
        description: 'I can make a Fully responsive front end static website with react and react web app performance are really really good.',
        icon: faCode
    }, {
        id: 2,
        title: 'E-COMMERCE WEB APP',
        description: 'I do build e-commerce web application with React, MongoDb, Redux and For payment Stripe Payment Gateway.',
        icon: faLaptopCode
    }, {
        id: 3,
        title: 'FULL STACK WEB APP',
        description: 'Using MERN Stack I usually make Full Stack Web Application and For Authentication Firebase.',
        icon: faLaptop
    }, {
        id: 4,
        title: 'Logo Design',
        description: 'I am a professional logo designer with over two years of working experience. I guarantee that you wont regret getting my service.Customer satisfaction is my top priority.',
        icon: faPaintBrush
    }, {
        id: 5,
        title: 'RESPONSIVE DESIGN',
        description: 'Responsive Web design is the approach that suggests that design and development should respond to the users behavior and environment based on screen size, platform and orientation.',
        icon: faMobileAlt
    }

]

const Services = () => {
    return (
        <>
            <div className="particles-bg">
                {/* <BubblesParticlesBackground /> */}
            </div>
            <section id="service" className="service section">
                <div className="container">
                    <div className="row">
                        <div className="section-title padd-15">
                            <h2>Services</h2>
                        </div>
                    </div>
                    <div className="row">

                        {
                            servicesData.map(service => <div key={service.id} className="service-box padd-15">
                                <div className="service-item">
                                    <div className="icon"><FontAwesomeIcon icon={service.icon} /></div>
                                    <h4>{service.title}</h4>
                                    <p>{service.description}</p>
                                </div>
                            </div>)
                        }

                    </div>
                </div>
            </section>
        </>
    );
};

export default Services;